import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {Stack} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";
import {AdminLessonPageContent} from "./AdminLessonPageContent";
import type {LessonResponse} from "@/app2/shared/data";

const useStyles = makeStyles()((_theme) => ({
	adminLessonPage: {
		"& > div": {
			width: "980px",
			maxWidth: "100%"
		}
	}
}));

/**
 * Admin Lesson Page (App2)
 *
 * Wrapper for create/edit lesson; delegates to AdminLessonPageContent.
 */
export const AdminLessonPage: FC = () => {
	const {lessonId} = useParams<{lessonId?: string}>();
	const {classes} = useStyles();
	const navigate = useNavigate();
	const entityId = lessonId ? parseInt(lessonId, 10) : undefined;

	const handleSaveResponse = (data: LessonResponse): void => {
		navigate(`/admin/lessons/${data.id}/edit-new`);
	};

	const handleDeleteResponse = (): void => {
		navigate("/admin/lessons");
	};

	const handleGetResponse = (data: LessonResponse | null, statusCode?: number): void => {
		if (statusCode === 404) {
			navigate("../");
			return;
		}
		if (data && entityId && data.id !== entityId) {
			navigate(`/admin/lessons/${data.id}/edit-new`, {replace: true});
		}
	};

	return (
		<Stack className={classes.adminLessonPage}>
			<AdminLessonPageContent
				lessonId={entityId}
				onSaveResponse={handleSaveResponse}
				onDeleteResponse={handleDeleteResponse}
				onGetResponse={handleGetResponse}
			/>
		</Stack>
	);
};
